// External training plan: athletes who already follow a structured plan
// (Runna, TrainingPeaks — anything with an iCal feed) paste the feed URL
// in Settings. The plan-feed function fetches and parses it; the coach
// then treats the plan as the default and adjusts it with today's metrics.

export interface PlannedWorkout {
  date: string; // yyyy-mm-dd
  title: string;
  details?: string;
  completed: boolean;
}

export const fetchTrainingPlan = async (icalUrl: string): Promise<PlannedWorkout[]> => {
  const response = await fetch(
    `/.netlify/functions/plan-feed?url=${encodeURIComponent(icalUrl)}`
  );
  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new Error(data?.error || `Plan feed error: ${response.status}`);
  }
  const { events } = (await response.json()) as { events: PlannedWorkout[] };
  return events;
};
